import React from "react";
import {
	StyleSheet,
} from "react-native";

import Style from "ae-style";
import Breakpoints from "react-native-dimensions-breakpoints";
import BlockView from "./BlockView";

const styles = StyleSheet.create({
	spacer: {
		width: Style.layout.marginLarge,
		height: Style.layout.marginLarge
	},
	smallSpacer: {
		width: Style.layout.marginSmall,
		height: Style.layout.marginSmall,
	}
});

export default function ButtonSpacer() {
	const style = Breakpoints.smallerThan("mobile") ? styles.smallSpacer : styles.spacer;
	return (
		<BlockView style={style} />
	);
}
